import axios from 'axios';
import {
  CasePublicAuthorityModel,
  SpecialRegulationsComplianceModel,
} from 'app/edozvola/cases/special-regulations-compliance/model/special-regulations-compliance.model';

export const saveCasePublicAuthority = async (idCase: string, casePublicAuthority: CasePublicAuthorityModel): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`api/special-regulations-compliance/case-public-authority/${idCase}`, casePublicAuthority)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const fetchCasePublicAuthorities = async (idCase: string, page: number, size: number, column: string, direction: string): Promise<any> => {
  if (idCase) {
    return await new Promise(resolve => {
      axios
        .get(`api/special-regulations-compliance/case-public-authority/find-all/${idCase}?page=${page}&size=${size}&column=${column}&direction=${direction}`)
        .then(response => resolve(response.data));
    });
  }
};

export const getCasePublicAuthority = async (idCasePublicAuthority: string): Promise<CasePublicAuthorityModel> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/special-regulations-compliance/case-public-authority/${idCasePublicAuthority}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const deleteCasePublicAuthority = async (idCasePublicAuthority: number): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .delete(`api/special-regulations-compliance/case-public-authority/${idCasePublicAuthority}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const moveCasePublicAuthorityOrderingUp = async (idCasePublicAuthority: number): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/special-regulations-compliance/case-public-authority/move-up/${idCasePublicAuthority}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const moveCasePublicAuthorityOrderingDown = async (idCasePublicAuthority: number): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/special-regulations-compliance/case-public-authority/move-down/${idCasePublicAuthority}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const saveSpecialRegulationsCompliance = async (idCase: string, specialRegulationsCompliance: SpecialRegulationsComplianceModel): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`api/special-regulations-compliance/${idCase}`, specialRegulationsCompliance)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  })
}

export const getSpecialRegulationsCompliance = async (idCase: string): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/special-regulations-compliance/${idCase}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  })
}

export const copyCasePublicAuthorities = async (caseUuid: string, caseUuidToCopyFrom: string): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/special-regulations-compliance/case-public-authority/copy/${caseUuid}/${caseUuidToCopyFrom}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};
